<template>
  <div>
    <title>操作记录</title>
    <article class="cardArticle">
      <main class="cardMain">
        <!--S 检索-->
        <el-form :model="searchRecordForm" inline class="searchForm operateForm">
          <el-form-item label="关键词">
            <el-input v-model="searchRecordForm.keyword" clearable placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="出库时间">
            <el-date-picker v-model="searchRecordForm.outBoundDate" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="券卡流向">
            <el-checkbox v-model="searchRecordForm.flowcode" :label="0">门店直发</el-checkbox>
          </el-form-item>
          <el-form-item label="">
            <MemberChoseSelecter v-model="searchRecordForm.membercode" placeholder="请选择会员"></MemberChoseSelecter>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query">查询</el-button>
          </el-form-item>
          <el-form-item class="borderline borderNone">
            <el-button type="primary" plain @click="outCheckExport(0)">按检索修改有效期</el-button>
            <el-button type="primary" v-show='!expoerHandle' plain @click="outCheckExport(1)">按勾选修改有效期</el-button>
            <el-button type="danger" icon="el-icon-close" round v-show='expoerHandle'
              @click="confirmCancel(0)">取消</el-button>
            <el-button type="success" icon="el-icon-check" round v-show='expoerHandle'
              @click="confirmCancel(1)">确定</el-button>
          </el-form-item>
        </el-form>
        <!-- E 检索 -->
        <section>
          <el-table ref="gsTable" class="comTable recordTable" border v-loading="vloading" :data="cardBatchList"
            :maxHeight="tableHeight" :row-key="tabItemKey" @selection-change="handleSelectionChange">
            <el-table-column v-if="expoerHandle" type="selection" fixed reserve-selection width="80"></el-table-column>
            <el-table-column fixed label="序号" type="index"></el-table-column>
            <el-table-column label="出库时间" width="200" fixed prop="outTime">
              <template slot-scope="scope">
                {{dateTime(scope.row.operdate,1)}}
              </template>
            </el-table-column>
            <el-table-column label="券卡流向" width="150" fixed prop="flow">
              <template slot-scope="scope">
                <!-- 注意：出库时流向为企业会员的时候，这里的券卡流向是【会员昵称】为手机号码的时候，这里的券卡流向是【总部直发】 -->
                <p class="textHiden" :title="scope.row.flowname">{{scope.row.flowname||'门店直发'}}</p>
                <!-- <p class="textHiden" v-else title="总部直发">总部直发</p> -->
                <!-- <p class="textHiden" title="会员昵称">会员昵称</p> -->
              </template>
            </el-table-column>
            <el-table-column label="总数" width="120" sortable prop="opernum" fixed>
              <template slot-scope="scope">
                <router-link
                  :to="{path:'ElectronRecordOutTotal',query:{batchcode:scope.row.batchcode,ecardrecvtype:scope.row.ecardrecvtype}}"
                  class="total priceFont"><i class="iconhand"></i>{{scope.row.opernum ||'0'}}</router-link>
              </template>
            </el-table-column>
            <el-table-column label="券卡用途" width="100">
              <template slot-scope="scope">
                {{scope.row.carduse | cardPurposeFilter}}
              </template>
            </el-table-column>
            <el-table-column label="定义类型" width="200">
              <template slot-scope="scope">
                {{scope.row.deftype | cardTypeFilter}}
              </template>
            </el-table-column>
            <el-table-column label="预售品牌" width="150">
              <template slot-scope="scope">
                <p class="textHiden" :title="scope.row.brandname">{{scope.row.brandname || '--'}}</p>
              </template>
            </el-table-column>
            <el-table-column label="专区数量" sortable width="100" prop="selzones">
              <template slot-scope="scope">
                <em class="priceFont">{{scope.row.selzones|| '0'}}</em>
              </template>
            </el-table-column>
            <el-table-column label="共可选择商品数" sortable width="150" prop="selnum">
              <template slot-scope="scope">
                <em class="priceFont">{{scope.row.selnum|| '0'}}</em>
              </template>
            </el-table-column>
            <el-table-column label="可使用次数" sortable width="120" prop="usenum">
              <template slot-scope="scope">
                <em class="priceFont">{{scope.row.usenum|| '0'}}</em>
              </template>
            </el-table-column>
            <el-table-column label="券卡类型" width="100">
              <template slot-scope="scope">
                <em class="textHiden" :title="scope.row.cardkind">{{scope.row.cardkind || '--'}}</em>
              </template>
            </el-table-column>
            <el-table-column label="券卡面值(￥)" sortable width="125" prop="cardprice">
              <template slot-scope="scope">
                <em class="priceFont">{{scope.row.cardprice | formatAmount}}</em>
              </template>
            </el-table-column>
            <el-table-column label="券卡售价(￥)" sortable width="125" prop="cardsmallprice">
              <template slot-scope="scope">
                <em class="priceFont">{{scope.row.cardsmallprice | formatAmount}}</em>
              </template>
            </el-table-column>
            <el-table-column label="有效期" width="120">
              <template slot-scope="scope">
                <p class="serial" v-if="scope.row.startvaldate">
                  {{dateTime(scope.row.startvaldate)}}
                  <em>~</em>
                  {{dateTime(scope.row.endvaldate)}}
                </p>
                <p class="serial" v-else>
                  长期有效
                </p>
              </template>
            </el-table-column>
            <el-table-column label="客服备注" width="200">
              <template slot-scope="scope">
                <p class="textHiden" :title="scope.row.sermemo">{{scope.row.sermemo || '--'}}</p>
              </template>
            </el-table-column>
            <el-table-column label="备注" width="200">
              <template slot-scope="scope">
                <p class="textHiden" :title="scope.row.memo">{{scope.row.memo || '--'}}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" fixed="right">
              <template slot-scope="scope">
                <el-dropdown placement="bottom-start" @command="getCommand" trigger="click">
                  <span class="el-dropdown-link" @click="allBatchcode(scope.row.batchcode)">
                    全部操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="getCoverDetailShow">详情</el-dropdown-item>
                    <el-dropdown-item command="11">修改</el-dropdown-item>
                    <el-dropdown-item command="4">回收</el-dropdown-item>
                    <el-dropdown-item command="2">暂停</el-dropdown-item>
                    <el-dropdown-item command="3">恢复</el-dropdown-item>
                    <!-- 流向为手机号时显示 -->
                    <el-dropdown-item command="5" v-if="scope.row.ecardrecvtype==0">短信重发</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <template slot="empty" v-if="vloading">
              <div :class="{noData:vloading}"></div>
            </template>
            <template slot="empty" v-else>
              <div class="noData"><span>暂无数据</span></div>
            </template>
          </el-table>
          <!-- S 暂停、恢复弹框 -->
          <el-dialog class="comDlog recoverDlog" title="提示" :visible.sync="recoverDialogVisible" append-to-body
            :close-on-click-modal="false">
            <p>当前可{{operateTxt}}数量：<i class="pink commonNum">{{num}}</i></p>
            <p>确定要进行{{operateTxt}}操作吗？</p>
            <p v-show="types==4" class="redColor">电子券回收后将永久作废，无法恢复使用。请谨慎操作！</p>
            <el-input type="textarea" v-model="recoverMemo" maxlength="100"
              :placeholder='"输入"+operateTxt+"备注"'></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" :loading="showLog" @click="getCoverSuccessShow(true)">确定</el-button>
              <el-button @click="getRecoverShow(false)">取消</el-button>
            </span>
          </el-dialog>
          <!-- E 暂停、恢复弹框 -->
          <!-- S 暂停、恢复成功弹框 -->
          <el-dialog class="comDlog recoverDlog" title="提示" :visible.sync="coverSuccessDialogVisible" append-to-body
            :close-on-click-modal="false">
            <div class="flexUpDownCenter coverSuccess">
              <i class="el-icon-warning"></i>
              <div>
                <p>批次成功{{operateTxt}}<i class="pink commonNum">{{batchOtherOper.num}}</i>张券卡</p>
                <em>对此生成一条{{operateTxt}}记录</em>
                <em>批次时间为：{{batchOtherOper.foperdate}}</em>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" :loading="showLog" @click="getCoverSuccessShow(false)">确定</el-button>
            </span>
          </el-dialog>
          <!-- E 暂停、恢复成功弹框 -->
          <!-- S 修改、出库弹框 -->
          <el-dialog class="comDlog recoverDlog" title="提示" :visible.sync="coverEditDialogVisible" append-to-body
            :close-on-click-modal="false">
            <div class="flexUpDownCenter coverSuccess">
              <i class="el-icon-warning"></i>
              <div>
                <p>当前可{{editTxt}}数量：{{num}}，确定要进行{{editTxt}}操作吗？</p>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="getCoverEdit(true)">确定</el-button>
              <el-button @click="getCoverEdit(false)">取消</el-button>
            </span>
          </el-dialog>
          <!-- E 修改、出库弹框 -->
          <!-- S 出库详情弹框 -->
          <OutDetail :cardInfo="cardInfo" :outDetailDialogVisible="outDetailDialogVisible"
            @closeChild="getCloseOutDetailCld"></OutDetail>
          <!-- E 出库详情弹框 -->
          <!-- S 分页 -->
          <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam">
          </Page>
          <!-- E 分页 -->
        </section>
      </main>
    </article>
    <!-- S 修改有效期弹窗 -->
    <el-dialog class="comDlog printDlg" title="修改有效期" :visible.sync="specialQueryShow" append-to-body
      :close-on-click-modal="false" :before-close="submitNum">
      <el-form :model="dateForm" label-width="120px" class="commonForm" v-loading="subLoading">
        <el-form-item label="修改对象">
          <el-radio-group v-model="dateForm.selvaldate">
            <el-radio :label="1">已过期券卡</el-radio>
            <el-radio :label="0">全部券卡</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效期" class="nomgbotItem">
          <!-- S 双日期选择器 -->
          <TwoDatePickers :noQuick="0" v-if="specialQueryShow" @twoDateObtain="twoDateReceive" :dateDelete="dateDelete">
          </TwoDatePickers>
          <!-- E 双日期选择器 -->
        </el-form-item>
        <el-form-item class="allWidth" label-width="100px">
          <p class="breathTit iconbulb">请选择需要设置的有效期，如不设置，则本次提交为<i class="redColor">"长期有效"</i>！</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitNum(1)" :loading="subLoading">确定</el-button>
        <el-button @click="submitNum(0)">取消</el-button>
      </span>
    </el-dialog>
    <!-- E 修改有效期弹窗 -->
    <!-- S 修改有效期确认提示框 -->
    <el-dialog class="comDlog recoverDlog dateDlog" title="提示" :visible.sync="confirmDateChangeShow" append-to-body
      :close-on-click-modal="false" :before-close="submitForm">
      <div class="flexUI coverSuccess">
        <i class="el-icon-warning"></i>
        <p>本次操作预计调整<span class="pink">{{dataNum}}</span>张券卡的有效期，<br>一旦提交，不可退回，确定提交吗？</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm(1)" :loading="subLoading">确定</el-button>
        <el-button @click="submitForm(0)">取消</el-button>
      </span>
    </el-dialog>
    <!-- E 修改有效期确认提示框 -->
  </div>
</template>
<script>
  import Api from "@/apis/api.js";
  import Vue from 'vue';
  import { Message, MessageBox } from "element-ui";
  export default {
    name: 'OperateRecord',
    components: {
      MemberChoseSelecter: resolve =>
        require(["@/components/OrderFolder/StoreSale/MemberChoseSelecter.vue"], resolve),
      Page: resolve => require(["@/components/common/Page.vue"], resolve),//分页
      OutDetail: resolve => require(["@/components/CardsFolder/OutDetail.vue"], resolve),//出库详情弹框
      TwoDatePickers: resolve => require(["@/components/common/TwoDatePickers.vue"], resolve), // 双日期选择器组件
    },
    data() {
      return {
        showLog: false,
        batchcodes: '',
        multipleSelection: [],
        dateForm: {
          selvaldate: 1,
        },//修改有效期表单
        confirmDateChangeShow: false,//确认提示
        dataNum: 0, // 批量修改日期时，可以操作的数量
        subLoading: false, // 提交时的弹窗遮罩
        updatetime1: '',
        updatetime2: '',
        dateDelete: false, // 是否清空日期选择器内容
        specialQueryShow: false,
        expoerHandle: false,
        vloading: false,
        types: 0,
        num: 0,
        cardInfo: '',
        batchcode: '',
        pageTotal: 0, //总数
        currentPage: 1, // 页数
        pageSize: 30, // 条数
        cardBatchList: [],
        batchOtherOper: '',
        // 检索表单
        searchRecordForm: {
          keyword: '',//关键词
          outBoundDate: '', //出库日期
          flowcode: '',
          membercode: '',
        },
        //选择时间
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        highShow: false,//是否展示高级筛选
        recoverMemo: '',//回收备注
        recoverDialogVisible: false,//回收弹框
        coverSuccessDialogVisible: false,//回收成功弹框
        outDetailDialogVisible: false,//出库详情弹框
        tableHeight: window.innerHeight * .8, //表格动态高度
        operateTxt: '',//弹框类型文字
        coverEditDialogVisible: false,//修改的弹框
        editTxt: '',//修改、出库文字
        paths: ''
      }
    },
    watch: {
      // 监听路由变化改变active的值
      $route(to, from) {
        this.paths = from.name
      },
      expoerHandle(val) {
        if (!val) {
          this.updatetime1 = '';
          this.updatetime2 = '';
          this.multipleSelection = [];
          this.batchcodes = '';
          this.$refs.gsTable.clearSelection(); // 清空选中列表数据
        }
      },
      specialQueryShow(val) {
        if (val) {
          this.$nextTick(() => {
            this.dateDelete = true;
          })

        }

      }
    },
    activated() {
      setTimeout(() => {
        if (this.paths == '电子券操作记录操作' || this.paths == '电子券管理操作记录总数') {
          this.getCardBatchList();
          //在dom渲染之后
          setTimeout(() => {
            this.getHeight();
          }, 200)
        } else {
          this.paths = '';
          this.vloading = false;
          this.batchOtherOper = '';
          this.types = '';
          this.nums = ''; //修改数
          this.batchcode = '';
          this.pageTotal = 0; //总数
          this.currentPage = 1; // 页数
          this.pageSize = 30; // 条数
          this.expoerHandle = false;
          this.specialQueryShow = false;
          this.dateDelete = false; // 是否清空日期选择器内容
          this.batchcodes = '';
          this.multipleSelection = [];
          // 检索表单
          this.searchRecordForm = {
            flowcode: '',
            keyword: '',//关键词
            membercode: '',
            outBoundDate: '', //出库日期
            cardmedium: '',//券卡用途
          };
          this.highShow = false;//是否展示高级筛选
          // 表格数据
          this.cardBatchList = [];
          this.recoverMemo = '';//回收备注
          this.recoverDialogVisible = false;//回收弹框
          this.coverSuccessDialogVisible = false;//回收成功弹框
          this.tableHeight = window.innerHeight * .8; //表格动态高度
          this.operateTxt = '';//弹框类型文字
          this.coverEditDialogVisible = false;//修改的弹框
          this.editTxt = '';//修改、出库文字
          this.outDetailDialogVisible = false;//出库详情弹框
          this.cardInfo = '';
          this.getCardBatchList();
          //在dom渲染之后
          setTimeout(() => {
            this.getHeight();
          }, 200)
        }
      }, 100)
    },
    // ==================================== 方法 ====================================
    methods: {
      submitForm(type) {
        if (type == 1) {
          this.outexport(this.uptype, 1);
        } else {
          this.dateDelete = true;
          this.updatetime1 = '';
          this.updatetime2 = '';
          this.dateForm.selvaldate = 1;
          this.confirmDateChangeShow = false;
          this.subLoading = false;
        }
      },
      // 日期选择值
      twoDateReceive(val) {
        if (val && val != null) {
          this.updatetime1 = this.dateTime(val[0]);
          this.updatetime2 = this.dateTime(val[1]);
        } else {
          this.updatetime1 = '';
          this.updatetime2 = '';
        }
      },
      submitNum(index) {
        if (index == 1) {
          this.outexport(this.uptype, 0);
        } else {
          this.dateDelete = true;
          this.updatetime1 = '';
          this.updatetime2 = '';
          this.dateForm.selvaldate = 1;
          this.specialQueryShow = false;
          this.subLoading = false;
        }
      },
      outexport(index, type) {
        let param = {}
        if (index == 0) {
          param = {
            uptype: this.uptype,
            updatetime1: this.updatetime1,
            updatetime2: this.updatetime2,
            codetype: 0,
            opertype: 0,
            cardmedium: 1,
            startvaldate: this.searchRecordForm.outBoundDate ? this.dateTime(this.searchRecordForm.outBoundDate[0]) : '',
            endvaldate: this.searchRecordForm.outBoundDate ? this.dateTime(this.searchRecordForm.outBoundDate[1]) : '',
            keyword: this.searchRecordForm.keyword,
            isjoinwxcardbag: this.searchRecordForm.isjoinwxcardbag,
            deftype: 0,
            flowcode: this.searchRecordForm.flowcode ? '0' : '',
            membercode: this.searchRecordForm.membercode,
            selvaldate: this.dateForm.selvaldate,
            isreturntype: type,
          }
        } else {
          param = {
            uptype: this.uptype,
            updatetime1: this.updatetime1,
            updatetime2: this.updatetime2,
            codetype: 0,
            opertype: 0,
            batchcodes: this.batchcodes,
            selvaldate: this.dateForm.selvaldate,
            isreturntype: type,
          }
        }
        this.subLoading = true;
        Api.BATCHUPDATEVALDATE(param).then(res => {
          if (res.data.status == "200") {
            if (type != 1) {
              if (this.specialQueryShow) {
                this.confirmDateChangeShow = true;
                this.specialQueryShow = false;
                this.dataNum = res.data.data;
              }
            } else {
              this.updatetime1 = '';
              this.updatetime2 = '';
              this.dateDelete = true;
              this.expoerHandle = false;
              this.confirmDateChangeShow = false;
              this.$message.success(res.data.message)
              this.getCardBatchList();
            }
          } else {
            this.$message.error(res.data.message)
          }
          this.subLoading = false;
        }).catch(res => {
          this.subLoading = false;
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.batchcodes = Array.from(this.multipleSelection, item => {
          return item.batchcode;
        }).join(",");
      },
      // 给每行设置唯一的key
      tabItemKey(row) {
        return row.batchcode;
      },
      outCheckExport(index) {
        this.uptype = index
        if (index == 0) {
          this.expoerHandle = false;
          this.specialQueryShow = true;
        } else {
          this.expoerHandle = true;
        }

      },
      confirmCancel(index) {
        this.expoerHandle = Boolean(index)
        if (index && !this.batchcodes) {
          MessageBox.alert("请至少勾选一项？", "系统提示", {
            confirmButtonText: "确定",
            type: "warning"
          })
            .then(() => { })
            .catch(() => { });
        } else if (index && this.batchcodes) {
          this.specialQueryShow = true;
        }
      },
      //查询
      query() {
        this.pageSize = 30;
        this.currentPage = 1;
        this.$refs.gsTable.bodyWrapper.scrollTop = 0;
        this.getCardBatchList();
      },
      // 分页
      nowPageParam(val, vals) {
        this.pageSize = val;
        this.currentPage = vals;
        this.$refs.gsTable.bodyWrapper.scrollTop = 0;
        this.getCardBatchList();
      },
      allBatchcode(batchcode) {
        this.recoverMemo = '';
        this.batchcode = batchcode;
      },
      // 下拉菜单事件
      getCommand(command) {
        this.types = command;
        if (command == 'getCoverDetailShow') {
          this.getCoverDetailShow();
          return
        }
        Api.GET_OPERNUM({ batchcode: this.batchcode, opertype: command, codetype: 0 }).then(res => {
          if (res.data.status == "200") {
            if (res.data.data > 0) {
              this.num = res.data.data;
              // 详情
              if (command == "4") {
                // 回收
                this.getRecoverShow('回收');
              } else if (command == "2") {
                // 暂停
                this.getRecoverShow('暂停');
              } else if (command == "3") {
                // 暂停
                this.getRecoverShow('恢复');
              } else if (command == "11") {
                this.editTxt = '修改';
                this.coverEditDialogVisible = true;
              } else if (command == "5") { //短信重发
                MessageBox.confirm('确定短信重发？', '提示', {
                  confirmButtonText: '确定',
                  dangerouslyUseHTMLString: true,
                  type: 'success'
                }).then(() => {
                  this.resendMsg();
                }).catch(() => { });
              }
            } else {
              this.num = 0;
              this.$message.error('当前批次没有可操作的券卡！');
            }
          }
        })
      },
      // 短信
      resendMsg() {
        Api.RESENDMSG({ code: this.batchcode, sendtype: 0, opertype: 0, cardmedium: 1 }).then(res => {
          if (res.data.status == "200") {
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
      },
      // 回收、暂停、恢复
      getRecoverShow(val) {
        if (val != false) {
          this.operateTxt = val;
          this.recoverDialogVisible = true;
        } else {
          this.recoverDialogVisible = false;
        }
      },
      // 修改
      getCoverEdit(val) {
        this.coverEditDialogVisible = false;
        if (val == false) {
          this.coverEditDialogVisible = false;
        } else if (this.editTxt == '修改') {
          this.$router.push({
            path: "/ElectronOperate",
            name: '电子券操作记录操作',
            params: { num: this.num },
            query: { batchcode: this.batchcode }
          });
        }
      },
      // 回收成功
      getCoverSuccessShow(val) {
        if (val == false) {
          this.recoverDialogVisible = false;
          this.coverSuccessDialogVisible = val;
          return
        }
        let param = {
          batchcode: this.batchcode,
          memo: this.recoverMemo,
          cardmedium: 1
        }
        if (this.types == 2 || this.types == 3) {
          this.showLog = true
          Vue.set(param, 'opertype', this.types)
          Api.BATCHOTHEROPER(param).then(res => {
            if (res.data.status == "200") {
              this.batchOtherOper = res.data.data;
              this.recoverDialogVisible = false;
              this.coverSuccessDialogVisible = val;
              this.showLog = false
            } else {
              this.showLog = false
              this.$message.error(res.data.message);
            }
          }).catch((err) => {
            this.showLog = false
          })
        }
        if (this.types == 4) {
          this.showLog = true
          Api.CARDBATCHRECYCLE(param).then(res => {
            if (res.data.status == "200") {
              this.batchOtherOper = res.data.data;
              this.recoverDialogVisible = false;
              this.coverSuccessDialogVisible = val;
              this.showLog = false
            } else {
              this.showLog = false
              this.$message.error(res.data.message);
            }
          }).catch((err) => {
            this.showLog = false
          })
        }
      },
      // 打开出库详情弹框
      getCoverDetailShow() {
        Api.GET_CARDBATCHDETAIL({ batchcode: this.batchcode }).then(res => {
          if (res.data.status == "200") {
            this.cardInfo = res.data.data;
            this.outDetailDialogVisible = true;
          }
        })
      },
      // 关闭出库详情弹框
      getCloseOutDetailCld() {
        this.outDetailDialogVisible = false;
      },
      //动态获取表格高度
      getHeight() {
        let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
        //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
        this.tableHeight = window.innerHeight - tbHeight - 125;
      },
      // 批次列表查询
      getCardBatchList() {
        this.vloading = true;
        let param = {
          codetype: 0,
          opertype: 0,
          deftype: 0,
          cardmedium: 1,
          flowcode: this.searchRecordForm.flowcode ? '0' : '',
          membercode: this.searchRecordForm.membercode,
          startvaldate: this.searchRecordForm.outBoundDate ? this.dateTime(this.searchRecordForm.outBoundDate[0]) : '',
          endvaldate: this.searchRecordForm.outBoundDate ? this.dateTime(this.searchRecordForm.outBoundDate[1]) : '',
          keyword: this.searchRecordForm.keyword,
          pageparam: {
            pagesize: this.pageSize, //每页条数
            currentpage: this.currentPage, //当前页数
          }
        }
        Api.GET_CARDBATCHLIST(param).then(res => {
          if (res.data.status == "200") {
            this.vloading = false;
            this.cardBatchList = res.data.data;
            this.pageTotal = res.data.pagebean.totalnum;
          } else {
            this.pageTotal = 0;
            this.cardBatchList = [];
          }
        })
      },
    },
    // ==================================== 生命周期 ====================================
    mounted() {
      this.getCardBatchList();
      //在dom渲染之后
      setTimeout(() => {
        this.getHeight();
      }, 200)
    },
    created() {
      //页面浏览器视窗变化绑定resize事件
      window.addEventListener("resize", this.getHeight);
    },
    destroyed() {
      window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
  }
</script>
<style scoped>
  .noData {
    height: 400px;
  }

  .cardArticle {
    position: relative;
    padding: 20px 20px 20px 20px;
    height: calc(100% - 169px);
  }

  /* S 检索 */
  .simpleSearch {
    line-height: 40px;
    color: var(--main-color);
    cursor: pointer;
    white-space: nowrap;
  }

  .operateForm {
    margin-bottom: 10px;
  }

  .operateForm>>>.el-form-item {
    margin-bottom: 10px;
  }

  .none {
    display: none;
  }

  .block {
    display: block;
  }

  /* E 检索 */
  /* S 表格 */
  .total {
    line-height: 20px;
    font-weight: bold;
  }

  .total i {
    font-size: 20px;
    margin-right: 5px;
    vertical-align: text-bottom;
  }

  .serial em {
    display: block;
    margin-left: 26px;
  }

  .serialPop ul {
    -o-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    max-height: 120px;
    overflow-y: auto;
  }

  .serialPop ul li {
    color: #666;
    line-height: 28px;
  }

  .recordTable .el-dropdown-link {
    cursor: pointer;
    color: var(--main-color);
  }

  .recordTable>>>.el-table__fixed-right-patch {
    background-color: #F5F7FA;
  }

  .recordTable>>>td:nth-child(5) .cell {
    overflow: initial;
  }

  .serialWrap {
    position: relative;
  }

  .serialPop {
    position: absolute;
    top: 30px;
    width: 370px;
    background: #fff;
    display: none;
    z-index: 1;
    border: 1px solid #E4E7ED;
    -o-box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    -ms-box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    padding: 10px 0;
  }

  .seriPopArrow {
    width: 100%;
    height: 10px;
    position: absolute;
    top: -10px;
  }

  .seriPopArrow::before {
    display: inline-block;
    content: "";
    position: absolute;
    left: 40px;
    top: 6px;
    width: 13px;
    height: 13px;
    background: #fff;
    -webkit-transform: rotate(-135deg);
    transform: rotate(-135deg);
    -webkit-box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
  }

  .serialWrap:hover .serialPop {
    display: block;
  }

  .serialWrap:hover a {
    color: var(--main-color);
  }

  /* E 表格 */
  /* S 回收弹框 */
  .recoverDlog>>>.el-dialog {
    width: 420px;
  }

  .recoverDlog>>>.el-dialog__footer {
    box-shadow: none;
    margin-bottom: 5px;
  }

  .recoverDlog>>>.el-button {
    padding: 8px 15px;
  }

  .recoverDlog p {
    color: #666;
    line-height: 25px;
  }

  .recoverDlog>>>.el-dialog__body {
    padding: 13px 20px 11px 20px;
  }

  .recoverDlog>>>.el-textarea {
    margin-top: 15px;
  }

  .pink {
    color: #F7615E;
    font-weight: bold;
    margin: 0 5px;
  }

  .el-icon-warning {
    color: #F2962C;
    font-size: 24px;
    margin-right: 15px;
  }

  .coverSuccess p {
    margin-bottom: 5px;
  }

  .coverSuccess em {
    display: block;
    line-height: 1.5;
  }

  /* E 回收弹框 */

  .printDlg >>> .el-dialog {width:600px;}
</style>


// WEBPACK FOOTER //
// src/views/CardsFolder/CardsElectron/CardRecord/ElectronRecordOut.vue